// Temporary mock auth — will swap for Supabase auth once backend is wired.
// Admin gate lets us build and preview admin-only INFINI X console pages.
export type Role = "guest" | "client" | "admin";

const KEY = "infinix.mockRole";

export function getRole(): Role {
  if (typeof window === "undefined") return "guest";
  return (localStorage.getItem(KEY) as Role) || "guest";
}

export function setRole(role: Role) {
  localStorage.setItem(KEY, role);
  window.dispatchEvent(new Event("infinix:role-changed"));
}

export function isAdmin() {
  return getRole() === "admin";
}
